<template>
  <div class="tab-content">
    <ValidationObserver ref="formPeiTab3" v-slot="{ dirty }">
      <SaveObserver name="saveObserverPeiTab3" :dirty="dirty">
        <SectionTitle
          icon="fas fa-puzzle-piece"
          content="III. Descripción del Funcionamiento del Estudiante"
          container-class="tag-badge-main-info mt-5 mb-4"
        />
        <Error
          is-alert-mode
          :message="
            'Al realizar una determinación para cambio de Impedimento debe oprimir el botón de Actualizar Impedimento para actualizar el mismo.'
          "
        />
        <SectionTitle
          :has-line="true"
          :content="titles.sectionA"
          container-class="mb-4"
        />

        <Error
          v-if="controversyIII && controversyIII.existControversy"
          is-alert-mode
          :message="
            '<b>Parte en Controversia: </b>' + controversyIII.informationMessage
          "
        />
        <Error
          v-if="getErrorMessage != ''"
          is-alert-mode
          :message="getErrorMessage"
        />

        <div class="eq-ask row" data-ai-target="functionLevelDescription">
          <strong class="col-12 mb-2 ml-3">Aprovechamiento:</strong>
        </div>

        <form>
          <div class="row ml-3" data-ai-target="functionLevelDescription">
            <ValidationProvider
              v-slot="{ invalid }"
              class="w-99"
              :rules="`${validationTriggered.validation ? 'required' : ''}`"
              immediate
              name=""
            >
              <CustomDropDown
                v-model="selectedApproach"
                placeholder="Seleccione"
                :disabled="
                  ((studentFunction.peiStatusCode != peisStatusdraft ||
                    !canEditTab3 ||
                    !canShowSectionbySelectionA) &&
                    correlationIsActive &&
                    !admendmentIsEmpty) ||
                    !isDraft
                "
                required
                fieldkey="id"
                fieldname="name"
                :options="approaches"
                :error="`${invalid ? 'error' : ''}`"
                :custom-error-msg="resources['3001']"
              />
            </ValidationProvider>
          </div>

          <div data-ai-target="functionLevelDescription">
          <ValidationProvider
            v-slot="{ invalid }"
            :rules="`${validationTriggered.validation ? 'required' : ''}`"
            immediate
            name=""
          >
            <FormTextArea
              id="FTAFunctionLevelDescription"
              :value="studentFunction.functionLevelDescription"
              @input="handleFunctionFieldInput('functionLevelDescription', $event)"
              class="w-99"
              :label="'Comentario'"
              :placeholder="''"
              :disabled="
                ((studentFunction.peiStatusCode != peisStatusdraft ||
                  !canEditTab3 ||
                  !canShowSectionbySelectionA) &&
                  correlationIsActive &&
                  !admendmentIsEmpty) ||
                  !isDraft
              "
              :maxlength="10000"
              :error-desc="`${invalid ? 'error' : ''}`"
              :custom-error-msg="resources['3003']"
              :show-ai-icon="aiAssistantEnabled"
              :highlighted="isAiFieldHighlighted('functionLevelDescription')"
            >
              <template #ai-icon>
                <AiSuggestionIcon
                  v-if="!isAiFieldHighlighted('functionLevelDescription')"
                  inline
                  @click="openAiAssistant('functionLevelDescription', $event)"
                />
              </template>
            </FormTextArea>
          </ValidationProvider>
          </div>
        </form>
        <SectionTitle
          :has-line="true"
          :content="titles.sectionB"
          container-class="mb-4"
        />

        <div class="eq-ask row">
          <span class="normalTitle">
            <b class="col-12 mb-2 ml-3">Impedimento:</b>
            {{ studentFunction.generalImpedimentDescription }}
          </span>
        </div>

        <form>
          <div data-ai-target="functionImpedimentDescription">
          <ValidationProvider
            v-slot="{ invalid }"
            :rules="`${validationTriggered.validation ? 'required' : ''}`"
            immediate
            name=""
          >
            <FormTextArea
              id="FTAFunctionImpedimentDescription"
              :value="studentFunction.functionImpedimentDescription"
              @input="handleFunctionFieldInput('functionImpedimentDescription', $event)"
              :label="'Comentario'"
              class="w-99"
              :disabled="
                ((studentFunction.peiStatusCode != peisStatusdraft ||
                  !canEditTab3 ||
                  !canShowSectionbySelectionB) &&
                  correlationIsActive &&
                  !admendmentIsEmpty) ||
                  !isDraft
              "
              :placeholder="'Escribir comentario…'"
              :maxlength="10000"
              :error-desc="`${invalid ? 'error' : ''}`"
              :custom-error-msg="resources['3010']"
              :show-ai-icon="aiAssistantEnabled"
              :highlighted="isAiFieldHighlighted('functionImpedimentDescription')"
            >
              <template #ai-icon>
                <AiSuggestionIcon
                  v-if="!isAiFieldHighlighted('functionImpedimentDescription')"
                  inline
                  @click="openAiAssistant('functionImpedimentDescription', $event)"
                />
              </template>
            </FormTextArea>
          </ValidationProvider>
          </div>
        </form>

        <div v-if="showInappropriateBehavior">
          <SectionTitle
            :has-line="true"
            :content="titles.sectionC"
            container-class="mb-4"
          />

          <div v-if="enableInappropriateBehaviorV2">
            <InappropriateBehaviorManagerV2
              :is-editable="isDraft"
              @studentBehaviorChanged="handleStudentBehaviorChanged"
            />
            <Error
              v-if="!!conductErrorMessage"
              :message="conductErrorMessage"
            />
          </div>

          <div v-else class="container-fluid table-W mt-n4">
            <div class="container-table-striped">
              <div class="table-responsive">
                <table class="table content-table-striped table-hover table-h">
                  <thead>
                    <tr class="row global-thead-dark thead-property">
                      <th class="col-md-12 text-center">
                        <span>Conducta Inapropiada</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="row">
                      <td class="col-md-12 p-0">
                        <div
                          v-for="(pFc,
                          pIndex) in studentFunction.peiFunctionConducts"
                          v-show="!showConductCollapse && !isPs"
                          :key="pIndex"
                        >
                          <div
                            class="custom-conduct-container-elements containerBorder pl-5 pt-4 pr-3 mb-0"
                            :class="[
                              (pIndex + 1) % 2 != 0
                                ? 'custom-conduct-container custom-conduct-container-active'
                                : 'custom-conduct-container custom-conduct-container-inactive',
                            ]"
                          >
                            <div class="information">
                              <span class="gray-pill">
                                Conducta Inapropiada # {{ pIndex + 1 }}
                              </span>
                              <p>{{ pFc.spaLongDescription }}</p>
                            </div>
                            <div
                              v-if="
                                isDraft &&
                                  canEditTab3 &&
                                  (canShowSectionbySelectionC ||
                                    !correlationIsActive ||
                                    admendmentIsEmpty)
                              "
                            >
                              <div class="dropdown">
                                <button
                                  id="dropdownMenuButton"
                                  class="btn btn-dropdown-actions dropdown-toggle float-right pt-1 custom-dropdown-block"
                                  type="button"
                                  data-toggle="dropdown"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                >
                                  Acciones
                                </button>
                                <div
                                  class="dropdown-menu dropdown-menu-right"
                                  aria-labelledby="dropdownMenuButton"
                                >
                                  <div
                                    class="dropdown-item"
                                    @click="editConductSelected(pFc, $event)"
                                  >
                                    <em class="fa fa-pencil text-green pr-1" />
                                    <span>Editar</span>
                                  </div>
                                  <div
                                    class="dropdown-item"
                                    @click="deleteConductSelected(pFc)"
                                  >
                                    <em
                                      class="fa fa-times-circle text-red pr-1"
                                    />
                                    <span>Eliminar</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="dropdown-divider dropdown-divider-custom mt-2 pb-2 w-100"
                            />
                            <div class="custom-container">
                              <span class="gray-pill">Estrategia:</span>
                              <p
                                v-for="(pFs,
                                eIndex) in pFc.peiGeneralFunctionStrategys"
                                :key="eIndex"
                              >
                                <b>{{ pIndex + 1 + '.' + (eIndex + 1) }}</b>
                                {{ pFs.spaLongDescription }}
                              </p>
                            </div>
                            <div class="custom-container">
                              <span class="gray-pill">
                                Colaboración Familiar:
                              </span>
                              <p
                                v-for="(pFcf,
                                cIndex) in pFc.peiGeneralFunctionFamilys"
                                :key="cIndex"
                              >
                                <b>{{ pIndex + 1 + '.' + (cIndex + 1) }}</b>
                                {{ pFcf.spaLongDescription }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div
              v-if="
                !isPs &&
                  !showConductCollapse &&
                  isDraft &&
                  canEditTab3 &&
                  (canShowSectionbySelectionC ||
                    !correlationIsActive ||
                    admendmentIsEmpty)
              "
              class="row bg-gray shadow2 w-100 resetmargin mt-n3"
            >
              <div
                v-if="studentFunction.configInapropriateConductFlag == 1"
                class="col-12 text-center areah"
              >
                <a href="#">
                  <button
                    id="btnFA"
                    class="btn bg-light-white w-75 py-2 mt-5"
                    @click="handleAddConduct"
                  >
                    <i class="fas fa-file-plus pr-4 text-green fa-lg" />
                    Añadir conducta inapropiada
                  </button>
                </a>
              </div>
              <br />
            </div>

            <Error
              v-if="validateInapropriateConduct()"
              variant="no-border"
              :message="resources['R03200122']"
            />

            <div
              v-if="
                showAccordionSections && activateAssistantServiceNeedGuideIsOn
              "
              class="row mx-auto pt-4 pb-3 col-12 inappropiate-alternatives"
            >
              <ValidationProvider
                v-slot="{ invalid }"
                :rules="`${validationTriggered.validation ? 'required' : ''}`"
                immediate
                name=""
                class="col-12 col-md-3 px-1"
              >
                <CustomDropDown
                  label="Conducta inapropiada:"
                  label-class="input-label font-14"
                  v-model="studentBehaviour"
                  placeholder="Seleccione"
                  :disabled="!isDraft || !canEditTab3"
                  required
                  fieldkey="id"
                  fieldname="name"
                  :options="studentInappropiateBehaviours"
                  :error="`${invalid ? 'error' : ''}`"
                  custom-error-msg="Favor de seleccionar."
                />
              </ValidationProvider>
            </div>

            <InappropriateBehaviorCollapseV1
              v-if="showAccordionSections"
              ref="inappropriateBehaviorv1"
              class="row mx-auto pt-4 pb-3 col-12 inappropiate-alternatives"
              :pei-id="peiId"
              :resources="resources"
              @update-function-conducts="handleUpdateFunctionConducts"
              @cancel="showConductCollapse = false"
            />
          </div>
        </div>

        <br />
        <div
          v-if="
            studentFunction.peiTransitionCode == peiTransitionsPostSecondary &&
              !isPs
          "
        >
          <SectionTitle
            :has-line="true"
            :content="titles.sectionD"
            container-class="mb-4"
          />
          <form>
            <ValidationProvider
              v-slot="{ invalid }"
              :rules="`${validationTriggered.validation ? 'required' : ''}`"
              immediate
              name=""
            >
              <FormTextAreaVisionTab3
                id="FTAPostscholarEducationDescription"
                v-model="
                  studentFunction.functionPostscholarEducationDescription
                "
                class="w-99"
                :label="'Educación'"
                :placeholder="'Escribir comentario…'"
                :disabled="
                  ((studentFunction.configTransitionServicesFlag == 0 ||
                    !isDraft ||
                    !canEditTab3 ||
                    !canShowSectionbySelectionD) &&
                    correlationIsActive &&
                    !admendmentIsEmpty) ||
                    studentFunction.peiStatusCode != peisStatusdraft
                "
                :maxlength="3000"
                :error-desc="`${invalid ? 'error' : ''}`"
                :custom-error-msg="resources['3007']"
              />
            </ValidationProvider>
          </form>
          <form>
            <ValidationProvider
              v-slot="{ invalid }"
              :rules="`${validationTriggered.validation ? 'required' : ''}`"
              immediate
              name=""
            >
              <FormTextAreaVisionTab3
                id="FTATransitionServices"
                v-model="studentFunction.functionPostscholarTrainingDescription"
                :label="'Adiestramiento'"
                :placeholder="'Escribir comentario…'"
                :disabled="
                  ((studentFunction.configTransitionServicesFlag == 0 ||
                    !isDraft ||
                    !canEditTab3 ||
                    !canShowSectionbySelectionD) &&
                    correlationIsActive &&
                    !admendmentIsEmpty) ||
                    studentFunction.peiStatusCode != peisStatusdraft
                "
                :maxlength="3000"
                class="w-99"
                :error-desc="`${invalid ? 'error' : ''}`"
                :custom-error-msg="resources['3008']"
              />
            </ValidationProvider>
          </form>
          <form>
            <ValidationProvider
              v-slot="{ invalid }"
              :rules="`${validationTriggered.validation ? 'required' : ''}`"
              immediate
              name=""
            >
              <FormTextAreaVisionTab3
                id="FTAPostscholarEmploymentDescription"
                v-model="
                  studentFunction.functionPostscholarEmploymentDescription
                "
                :label="'Empleo'"
                class="w-99"
                :placeholder="'Escribir comentario…'"
                :disabled="
                  ((studentFunction.configTransitionServicesFlag == 0 ||
                    !isDraft ||
                    !canEditTab3 ||
                    !canShowSectionbySelectionD) &&
                    correlationIsActive &&
                    !admendmentIsEmpty) ||
                    studentFunction.peiStatusCode != peisStatusdraft
                "
                :maxlength="3000"
                :error-desc="`${invalid ? 'error' : ''}`"
                :custom-error-msg="resources['3009']"
              />
            </ValidationProvider>
          </form>
          <form>
            <ValidationProvider
              v-slot="{ invalid }"
              :rules="`${validationTriggered.validation ? 'required' : ''}`"
              immediate
              name=""
            >
              <FormTextAreaVisionTab3
                :id="'FTAPostscholarIndependentDescription'"
                v-model="
                  studentFunction.functionPostscholarIndependentDescription
                "
                :label="'Vida Independiente'"
                class="w-99"
                :placeholder="'Escribir comentario…'"
                :disabled="
                  ((studentFunction.configTransitionServicesFlag == 0 ||
                    !isDraft ||
                    !canEditTab3 ||
                    !canShowSectionbySelectionD) &&
                    correlationIsActive &&
                    !admendmentIsEmpty) ||
                    studentFunction.peiStatusCode != peisStatusdraft
                "
                :maxlength="3000"
                :error-desc="`${invalid ? 'error' : ''}`"
                :custom-error-msg="resources['3012']"
              />
            </ValidationProvider>
          </form>
        </div>

        <AiAssistantModal
          :visible="aiModal.visible"
          :loading="aiModal.loading"
          :error="aiModal.error"
          title="Asistente Virtual"
          loading-text="Generando Redacción Sugerida..."
          :loading-subtext="aiLoadingSubtext"
          :context-label="aiContextLabel"
          :best-practices="aiModal.bestPractices"
          :documents="aiDocuments"
          :anchor-rect="aiModal.anchorRect"
          :can-refine="!!aiModal.fields.length"
          :can-give-feedback="!!(aiModal.fields.length && aiModal.aiGenerationLogId)"
          :feedback="aiModal.feedback"
          :feedback-submitting="aiModal.feedbackSubmitting"
          @close="closeAiAssistant"
          @refine="handleRefine"
          @feedback="handleFeedback"
        >
          <!--
            US 156915/156983 - "Contexto detectado" oculto por ahora a pedido del PO (por ej.
            mientras se resuelve el tema del spotlight, ya que esta sección le suma alto extra
            al modal). El contexto SIGUE llegando y usándose igual: esta sección es solo la
            vista de lo que el Orquestador detectó, no afecta el prompt enviado a la IA ni el
            registro de auditoría de generación en BE -- ambos siguen funcionando igual estando
            oculta. Para reactivarla, descomentar este bloque (y las clases .ai-modal-context*
            en el <style> de este archivo).

          <div v-if="aiModal.contexto && aiModal.contexto.length" class="ai-modal-context">
            <p class="ai-modal-context-title">Contexto detectado:</p>
            <ul class="ai-modal-context-list">
              <li
                v-for="(source, index) in aiModal.contexto"
                :key="index"
                :class="{ 'ai-modal-context-missing': !source.found }"
              >
                <i :class="source.found ? 'fas fa-check' : 'fas fa-exclamation-triangle'" />
                {{ sourceLabel(source) }}
              </li>
            </ul>
          </div>
          -->

          <div v-if="aiModal.fields.length" class="ai-modal-suggestion-title">
            <AiSparkIcon :size="14" />
            Redacción Sugerida
          </div>
          <div
            v-for="field in aiModal.fields"
            :key="field.key"
            class="ai-modal-suggestion"
          >
            <div class="ai-modal-suggestion-header">
              <div class="ai-modal-suggestion-header-left">
                <div class="ai-modal-suggestion-label">{{ field.label }}:</div>
                <span
                  v-if="aiEditWasEdited(field, 'value')"
                  class="ai-modal-suggestion-edited-tag"
                >
                  <i class="fa fa-pencil" /> Editado
                </span>
              </div>
              <!-- botón único (ícono) para Editar/Cancelar -- ver el mismo comentario
                   en GoalsManager.vue (íconos de FontAwesome, ya usados en el resto de la app, en
                   vez de componentes SVG propios). Antes vivía en una fila de acciones propia
                   debajo del texto (.ai-modal-suggestion-edit-actions, ya sacada) -- mockup
                   aprobado por el usuario para no competir con la fila de Regenerar/Usar Esta
                   Versión de abajo. -->
              <button
                type="button"
                class="ai-btn-icon"
                :class="{ 'ai-btn-icon--active': aiEditIsActive(field) }"
                :title="aiEditIsActive(field) ? 'Cancelar edición' : 'Editar'"
                @click="aiEditToggle(field, 'value')"
              >
                <i v-if="aiEditIsActive(field)" class="fas fa-times" />
                <i v-else class="fa fa-pencil" />
              </button>
            </div>
            <textarea
              v-if="aiEditIsActive(field)"
              v-model="field._aiEditText"
              class="ai-modal-suggestion-text-edit"
              rows="3"
            />
            <div v-else class="ai-modal-suggestion-text">
              {{ field.value }}
            </div>
          </div>

          <div v-if="aiModal.fields.length" class="ai-modal-actions">
            <button
              type="button"
              class="ai-btn ai-btn-outline"
              :disabled="aiModal.loading"
              @click="handleRegenerate"
            >
              <i class="fas fa-rotate-left" /> Regenerar
            </button>
            <button
              type="button"
              class="ai-btn ai-btn-primary"
              :disabled="aiModal.loading"
              @click="handleUseVersion"
            >
              <AiSparkIcon :size="13" variant="white" /> Usar Esta Versión
            </button>
          </div>

        </AiAssistantModal>
      </SaveObserver>
    </ValidationObserver>
  </div>
</template>

<script>
import { SectionTitle } from '@/components/pei/shared';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import peiStatuses from '@/utils/constants/pei/peiStatus';
import peiTransitions from '@/utils/constants/pei/peiTransitions';
import CustomDropDown from '@/components/common/CustomDropDown.vue';
import FormTextArea from '@/components/common/form/FormTextArea.vue';
import FormTextAreaVisionTab3 from '@/components/common/form/FormTextAreaVisionTab3.vue';
import SaveObserver from '@/components/common/SaveObserver';
import Error from '@/components/common/Error';
import alert from '@/mixin/alert.mixin';
import store from '@/store/index';
import peiSections from '@/utils/constants/pei/peiSections.js';
import { StudentInappropiateBehaviourOptions } from '@/components/pei/tabs/components/tab3/enum/StudentInappropiateBehaviourOptions';
import { getSysparameterByNames } from '@/modules/system-parameter-managment/api';
import InappropriateBehaviorManagerV2 from '@/components/pei/tabs/components/tab3/InappropriateBehaviorV2/Manager.vue';
import InappropriateBehaviorCollapseV1 from '@/components/pei/tabs/components/tab3/InappropriateBehaviorV1/Manager.vue';
import AiSuggestionIcon from '@/components/pei/shared/ai-assistant/AiSuggestionIcon.vue';
import AiAssistantModal from '@/components/pei/shared/ai-assistant/AiAssistantModal.vue';
import AiSparkIcon from '@/components/pei/shared/ai-assistant/AiSparkIcon.vue';
import aiSuggestionEditMixin from '@/components/pei/shared/ai-assistant/aiSuggestionEditMixin.js';

// Services.
import resourcesService from '@/services/resources.js';
import {
  generateSuggestion,
  refineSuggestion,
  markSuggestionUsed,
  submitFeedback,
} from '@/services/pei/aiAssistant.js';

const SUBSECTION_A = 25;
const SUBSECTION_B = 26;
const SUBSECTION_C = 27;
const SUBSECTION_D = 28;

export default {
  name: 'Tab3PEI',
  mixins: [alert, aiSuggestionEditMixin],
  components: {
    ValidationObserver,
    ValidationProvider,
    SectionTitle,
    FormTextArea,
    CustomDropDown,
    SaveObserver,
    Error,
    FormTextAreaVisionTab3,
    InappropriateBehaviorManagerV2,
    InappropriateBehaviorCollapseV1,
    AiSuggestionIcon,
    AiSparkIcon,
    AiAssistantModal,
  },
  computed: {
    // Documentos que la IA leyó para esta sugerencia, aplanados de todas las fuentes del
    // contexto detectado (hoy solo las fuentes documentales los traen, ej. Pruebas Académicas).
    // Se muestran en el panel para que el especialista -- que es quien firma el PEI -- vea de
    // dónde salió cada dato y si se pudo confirmar que el documento es de este estudiante.
    aiDocuments() {
      const fuentes = this.aiModal.contexto || [];

      return fuentes
        .filter((fuente) => Array.isArray(fuente.documents) && fuente.documents.length)
        .flatMap((fuente) => fuente.documents);
    },
    // Nombre legible del campo sobre el que trabaja el asistente -- alimenta la caja
    // "Contexto:" del modal y la segunda linea del estado de carga, como en el mockup de
    // Figma ("Contexto: Comentario de Salud" / "El asistente esta redactando ...").
    aiContextLabel() {
      const labels = {
        functionLevelDescription: 'Comentario · Funcionamiento académico (III-A)',
        functionImpedimentDescription: 'Comentario · Efecto del impedimento (III-B)',
      };
      return labels[this.aiModal.activeFieldKey] || '';
    },
    aiLoadingSubtext() {
      const partes = {
        functionLevelDescription: 'III-A',
        functionImpedimentDescription: 'III-B',
      };
      const parte = partes[this.aiModal.activeFieldKey];
      return parte ? `El asistente está redactando el Comentario de la Parte ${parte}` : '';
    },
    validationTriggered: function() {
      return store.getters.getPeiValidationTriggered;
    },
    admendmentIsEmpty() {
      return this.$store.state['$_admendment'].sections.length == 0;
    },
    hasSubSectionASelectedInAmendant() {
      return this.$store.state['$_admendment'].sections.some(
        (x) => x.subSectionId == SUBSECTION_A
      );
    },
    hasSubSectionBSelectedInAmendant() {
      return this.$store.state['$_admendment'].sections.some(
        (x) => x.subSectionId == SUBSECTION_B
      );
    },
    hasSubSectionCSelectedInAmendant() {
      return this.$store.state['$_admendment'].sections.some(
        (x) => x.subSectionId == SUBSECTION_C
      );
    },
    hasSubSectionDSelectedInAmendant() {
      return this.$store.state['$_admendment'].sections.some(
        (x) => x.subSectionId == SUBSECTION_D
      );
    },
    correlationIsActive() {
      const param = this.$store.state['$_admendment']?.correlationParameter;
      return Array.isArray(param) && param[0]?.staticValue === 'true';
    },
    canShowSectionbySelectionA() {
      return this.hasSubSectionASelectedInAmendant && !this.admendmentIsEmpty;
    },
    canShowSectionbySelectionB() {
      return this.hasSubSectionBSelectedInAmendant && !this.admendmentIsEmpty;
    },
    canShowSectionbySelectionC() {
      return this.hasSubSectionCSelectedInAmendant && !this.admendmentIsEmpty;
    },
    canShowSectionbySelectionD() {
      return this.hasSubSectionDSelectedInAmendant && !this.admendmentIsEmpty;
    },
    showAccordionSections: function() {
      return (
        this.showConductCollapse &&
        this.studentFunction.configInapropriateConductFlag == '1'
      );
    },
    controversyIII() {
      return store.getters.getPeiControversies(peiSections.III);
    },
    isDraft() {
      return store.getters.SelectedPeiStatus == peiStatuses.Borrador;
    },
    // El asistente solo se ofrece con el parámetro activo y el PEI en Borrador.
    aiAssistantEnabled() {
      return this.aiAssistantParamEnabled && this.isDraft;
    },
    getErrorMessage() {
      const errors = this.validationTriggered.getPvAlerts('Tab3');
      let message = '';
      errors?.map(function(error) {
        if (error.id.toLowerCase().includes('pv-')) {
          message += error.name + '<br/>';
        }
      });

      return message;
    },
    conductErrorMessage() {
      const error3002 = this.validationTriggered.errors('Tab3', 3002);
      const errorUS105671 = this.validationTriggered.errors('Tab3', 'US105671');

      if (error3002) return error3002;

      // US150821 - show the same message as the error 3002
      if (errorUS105671) return this.resources['3002'];
    },
    showInappropriateBehavior() {
      return (
        this.studentFunction?.configInapropriateConductFlag == 1 && !this.isPs
      );
    },
    enableInappropriateBehaviorV2() {
      return (
        this.showInappropriateBehavior && this.isEnabledInappropriateBehaviorV2
      );
    },
  },
  data() {
    return {
      isEnabledInappropriateBehaviorV2: false,
      studentInappropiateBehaviours: StudentInappropiateBehaviourOptions,
      isPs: store.state.pei.configUnilateralFlag == '1',
      peisStatusdraft: parseInt(peiStatuses.Borrador),
      peiTransitionsPostSecondary: peiTransitions.PostSecondary,
      titles: {
        sectionA: 'A. Nivel actual de funcionamiento académico general',
        sectionB:
          'B. Explique cómo este afecta la participación y progreso del estudiante en el currículo general',
        sectionC:
          'C. Si el estudiante muestra una conducta inapropiada que impide su aprendizaje y progreso o el de otros',
        sectionD:
          'D. Si el estudiante tiene o cumplirá 16 años en el periodo de implementación de este PEI, describa brevemente la visión de los que se espera que ocurra en su vida postescolar en las siguientes áreas',
      },
      approaches: [],
      selectedApproach: null,
      studentFunction: {
        functionImpedimentDescription: '',
        functionLevelDescription: '',
        functionLevelDescriptionAiGenerationLogId: null,
        functionImpedimentDescriptionAiGenerationLogId: null,
        configInapropriateConductFlag: '',
        peiStatusCode: 0,
      },
      peiId: store.getters.SelectedPei,
      conductSelected: null,
      showConductCollapse: false,
      resources: [],
      canEditTab3: store.getters.HasPermission('pei.editTab3'),
      studentBehaviour: null,
      activateAssistantServiceNeedGuideIsOn: false,
      // US 156909 - Parámetro de sistema para el Asistente de IA [Activar/Desactivar].
      aiAssistantParamEnabled: false,
      aiModal: {
        visible: false,
        loading: false,
        error: '',
        contexto: [],
        fields: [],
        // Posición (getBoundingClientRect) del botón "Usar IA" que disparó el asistente.
        anchorRect: null,
        // Recomendaciones de redaccion que llegan configuradas por seccion desde el
        // Orquestador (mismo registro de configuracion que ya se edita en Operaciones >
        // Configuracion de Prompts de IA). null = la seccion no tiene nada configurado y
        // el bloque no se pinta.
        bestPractices: null,
        aiGenerationLogId: null,
        // Feedback explícito ("¿Te fue útil esta sugerencia?") sobre ESTA corrida puntual --
        // 'up' | 'down' | null. Se resetea cada vez que cambia aiGenerationLogId (nueva
        // generación/regenerar/refinar), porque el feedback es por corrida, no acumulativo.
        feedback: null,
        feedbackSubmitting: false,
        // Campo sobre el que se pidió la sugerencia (III-A o III-B) -- el backend hoy
        // devuelve ambos textos en una sola llamada, pero cada ícono solo debe mostrar
        // y aplicar el que le corresponde a SU campo, nunca los dos juntos.
        activeFieldKey: null,
      },
    };
  },
  methods: {
    handleStudentBehaviorChanged(studentBehaviourId) {
      this.studentBehaviour = this.studentInappropiateBehaviours.find(
        (x) => x.id === studentBehaviourId
      );
    },
    saveTab() {
      store.dispatch('saveChangesOnForm');
    },
    updateImpedimentInfo(response) {
      let self = this;
      if (self.studentFunction.generalImpedimentId !== response.data.id) {
        self.studentFunction.generalImpedimentDescription = response.data.name;
        self.studentFunction.generalImpedimentId = response.data.id;

        self.ShowToast(
          '',
          'Se actualizó el impedimento del PEI exitosamente.',
          'success'
        );
      } else {
        self.ShowToast(
          'Sin cambios',
          'No se han detectado cambios en el impedimento.',
          'warning'
        );
      }
    },
    async getStudentFunction() {
      try {
        const res = await this.$ApiGet(
          `/api/pei/${this.peiId}/getstudentfunction`
        );
        this.studentFunction = res.data;

        if (this.studentFunction.peiFunctionLevelCode) {
          this.setSelectedApproach(this.studentFunction.peiFunctionLevelCode);
        }

        this.studentBehaviour = res.data?.inappropriateConductAlternative
          ? this.studentInappropiateBehaviours?.find(
              (x) => x.id === res.data.inappropriateConductAlternative
            )
          : null;
      } catch (err) {
        this.response = err;
      }
    },
    async getApproaches() {
      try {
        const res = await this.$ApiGet(`/api/pei/getfunctionlevel`);
        this.approaches = res.data;
      } catch (err) {
        this.response = err;
      }
    },
    async save() {
      this.studentFunction.peiFunctionLevelCode =
        this.selectedApproach && this.selectedApproach.id != 0
          ? this.selectedApproach.id
          : null;

      this.studentFunction.inappropriateConductAlternative = this.studentBehaviour?.id;

      try {
        await this.$ApiPost(
          `api/pei/${this.peiId}/savestudentfunction`,
          this.studentFunction
        );
        this.ShowToast(
          this.resources['R03200110'],
          this.resources['R03200109'],
          'success'
        );
      } catch (err) {
        this.ShowToast(err, this.resources['R03200108'], 'error');
      }
    },
    async deleteConductSelected(peiFucntionConduct) {
      let response = await alert.methods.ShowCancelModal(
        'Atención',
        '¿Está seguro que desea eliminar la conducta inapropiada ' +
          peiFucntionConduct.spaLongDescription +
          '?',
        'Si',
        'No'
      );
      if (!response) return;

      try {
        const res = await this.$ApiGet(
          `/api/pei/peiFunctionConductDelete?peiId=${this.peiId}&peiFunctionConductId=${peiFucntionConduct.peiFunctionConductId}`
        );
        this.studentFunction.peiFunctionConducts = res.data;

        this.ShowToast('', 'La conducta fue eliminada exitosamente', 'success');
      } catch (err) {
        const message =
          err && err.response && err.response.data
            ? err.response.data.message
            : this.resources['R03200108'];

        this.ShowToast('Error', message, 'error');
      }
    },
    handleAddConduct(evt) {
      evt.preventDefault();
      evt.stopImmediatePropagation();

      this.showConductCollapse = true;
    },
    async editConductSelected(conduct, evt) {
      evt.preventDefault();
      this.showConductCollapse = true;
      await this.$nextTick();
      await this.$refs.inappropriateBehaviorv1.setEditConductSelected(conduct);
    },
    // Events Handler.
    setSelectedApproach(approachId) {
      let approachName = this.approaches.find((x) => x.id === approachId).name;

      this.selectedApproach = {
        id: approachId,
        name: approachName,
      };
    },
    // Validations.
    // Validation for student with inapropriate conduct
    validateInapropriateConduct() {
      return (
        !this.isPs &&
        this.validationTriggered.validation &&
        this.studentFunction.configInapropriateConductFlag == 1 &&
        this.studentFunction.peiFunctionConducts.length <= 0
      );
    },
    handleUpdateFunctionConducts(data) {
      this.studentFunction.peiFunctionConducts = [...data];
      this.showConductCollapse = false;
    },
    async loadResources() {
      let resourceCodes = [
        '3001',
        '3002',
        '3003',
        '3010',
        '3011',
        '3007',
        '3008',
        '3009',
        '3012',
        'R03200120',
        'R03200121',
        'R03200122',
        'R03200110',
        'R03200109',
        'R03200108',
        'US111902',
      ];

      this.resources = await resourcesService.LoadValidationMessages(
        resourceCodes
      );
    },
    // --- US 156915 / 156983 - Asistente de IA para Parte III-A y III-B. ---
    // fieldKey: 'functionLevelDescription' (III-A, "Comentario" bajo Aprovechamiento) o
    // 'functionImpedimentDescription' (III-B, "Comentario" bajo Impedimento). Cada ícono
    // dispara AHORA una configuración de agente distinta en el backend (AG-01 = SeccionArea
    // 'III-A', AG-02 = SeccionArea 'III-B' -- ver 009_Update_AIPromptConfiguration_PEI_IIIA_
    // And_Seed_IIIB.sql), con su propio prompt/fuentes de contexto según el Plan de
    // Integración de Agentes de IA en el PEI. Ya NO es una sola llamada combinada filtrada
    // en el front -- son dos agentes independientes, cada uno resuelto por SU sectionArea.
    async openAiAssistant(fieldKey, event) {
      this.aiModal.activeFieldKey = fieldKey;
      // Se limpian las buenas prácticas de la apertura anterior: son por Sección/Área, así que
      // las de III-A no deben quedar visibles al abrir el asistente de III-B mientras carga.
      this.aiModal.bestPractices = null;
      // Posición del botón que disparó el asistente, para que el diálogo "small" se abra
      // pegado a él (con la colita apuntando hacia el botón, como en el mockup de Figma).
      const rect = event?.currentTarget?.getBoundingClientRect();
      this.aiModal.anchorRect = rect
        ? { top: rect.top, bottom: rect.bottom, left: rect.left, right: rect.right, width: rect.width, height: rect.height }
        : null;
      this.aiModal.visible = true;
      await this.requestAiSuggestion();
    },
    closeAiAssistant() {
      this.aiModal.visible = false;
    },
    // true mientras el asistente está abierto para ESE fieldKey. Usado para dos cosas: (1)
    // pasarlo como prop `highlighted` a FormTextArea, que lo reenvía a CustomTextArea para
    // pintar el border + fondo violeta directamente en la caja blanca del <textarea> (como
    // en Figma) -- no en el wrapper con data-ai-target (vestigio del spotlight con
    // blur+máscara SVG que tenía el modal antes, ver AiAssistantModal.vue), que también
    // incluye el label y a veces un dropdown, y (2) ocultar el ícono/chip "Usar IA" de ESE
    // campo mientras su propio asistente ya está abierto (no tiene sentido volver a
    // dispararlo sobre sí mismo).
    isAiFieldHighlighted(fieldKey) {
      return this.aiModal.visible && this.aiModal.activeFieldKey === fieldKey;
    },
    // fieldKey -> SeccionArea de CODE_AIPromptConfiguration. Mapeo fijo a propósito (no
    // se deriva de texto libre) para que un fieldKey desconocido caiga de forma explícita
    // en 'III-A' en vez de fallar en silencio.
    getSeccionAreaForField(fieldKey) {
      const map = {
        functionLevelDescription: 'III-A',
        functionImpedimentDescription: 'III-B',
      };
      return map[fieldKey] || 'III-A';
    },
    async requestAiSuggestion() {
      this.aiModal.loading = true;
      this.aiModal.error = '';
      try {
        const sectionArea = this.getSeccionAreaForField(
          this.aiModal.activeFieldKey
        );
        const { data } = await generateSuggestion({
          module: 'PEI',
          sectionArea,
          campo: null,
          peiId: this.peiId,
        });
        this.applyAiResult(data);
      } catch (err) {
        this.aiModal.error =
          err?.response?.data ||
          'No se pudo generar la sugerencia. Intente nuevamente.';
      } finally {
        this.aiModal.loading = false;
      }
    },
    applyAiResult(result) {
      this.aiModal.aiGenerationLogId = result.aiGenerationLogId;
      this.aiModal.feedback = null;
      this.aiModal.feedbackSubmitting = false;
      this.aiModal.contexto = result.detectedContext || [];
      // El "||" conserva las que ya venían: "Refinar" vuelve a pintar el panel completo con la
      // respuesta nueva, y si esa respuesta no las trajera, la caja desaparecería a mitad de uso.
      this.aiModal.bestPractices = result.bestPractices || this.aiModal.bestPractices || null;

      if (result.isBlocked) {
        this.aiModal.error = result.blockedReason;
        this.aiModal.fields = [];
        return;
      }

      let parsed = {};
      try {
        parsed = JSON.parse(result.suggestion);
      } catch (e) {
        parsed = {};
      }

      // III-A devuelve UN SOLO campo (descripcion) desde el 25 ago 2026 -- antes también
      // devolvía "aprovechamiento" y el modal lo mostraba para auto-seleccionarlo en el
      // dropdown, pero se confirmó que eso estaba al revés: Aprovechamiento es un DATO de
      // ENTRADA (lo que el maestro ya seleccionó, ver PeiGeneral.PeiFunctionLevelCode),
      // no algo que la IA deba proponer -- ahora solo se usa como fuente de contexto (ver
      // ResolveDatosEstudianteAsync en PeiAIContextBuilderEngine.cs) para redactar el
      // Comentario. III-B tampoco devuelve más que descripcion (el "Impedimento"
      // categórico no es editable por IA en esta pantalla -- viene de otra fuente, ver
      // generalImpedimentDescription).
      //
      // "kind" le dice a handleUseVersion() CÓMO aplicar cada campo -- hoy solo existe
      // 'text' (va directo a studentFunction[key]), pero se deja el campo por si algún
      // día vuelve a hacer falta distinguir cómo aplicar un campo nuevo.
      //
      // el modelo puede devolver "descripcion" partida en párrafos -- se aplana a texto
      // corrido acá, ANTES de guardarla en el campo (ver aiFlattenSuggestionText en
      // aiSuggestionEditMixin.js), para que quede así tanto en la vista previa como al
      // aplicarla con "Usar Esta Versión" (handleUseVersion -> aiEditFinalText).
      const descripcion = this.aiFlattenSuggestionText(parsed.descripcion);
      const fieldsByKey = {
        functionLevelDescription: [
          {
            key: 'functionLevelDescription',
            kind: 'text',
            label: 'Comentario',
            value: descripcion,
          },
        ],
        functionImpedimentDescription: [
          {
            key: 'functionImpedimentDescription',
            kind: 'text',
            label: 'Comentario',
            value: descripcion,
          },
        ],
      };

      this.aiModal.fields = fieldsByKey[this.aiModal.activeFieldKey] || [];
    },
    handleRegenerate() {
      this.requestAiSuggestion();
    },
    // Ya no hay wrapper local (submitRefine) -- el input de "Refinar Resultado" vive en
    // AiAssistantModal.vue, que emite 'refine' con la instrucción ya recortada.
    async handleRefine(instruccion) {
      if (!this.aiModal.aiGenerationLogId) return;
      this.aiModal.loading = true;
      this.aiModal.error = '';
      try {
        const { data } = await refineSuggestion({
          aiGenerationLogId: this.aiModal.aiGenerationLogId,
          teacherInstruction: instruccion,
        });
        this.applyAiResult(data);
      } catch (err) {
        this.aiModal.error =
          err?.response?.data ||
          'No se pudo refinar la sugerencia. Intente nuevamente.';
      } finally {
        this.aiModal.loading = false;
      }
    },
    // Reemplaza el v-model plano de functionLevelDescription/functionImpedimentDescription --
    // solo dispara con tecleo real del especialista (evento input del textarea), nunca con la
    // asignación programática de handleUseVersion() -- así, editar a mano después de usar una
    // sugerencia desvincula el campo de esa corrida (ver LogAiGenerationAppliedField).
    handleFunctionFieldInput(fieldKey, value) {
      this.studentFunction[fieldKey] = value;
      this.studentFunction[`${fieldKey}AiGenerationLogId`] = null;
    },
    handleUseVersion() {
      // Llena los campos en memoria (studentFunction) y enseguida autoguarda (ver
      // saveTab() más abajo) -- antes quedaba solo en memoria pendiente de que el
      // especialista recordara darle "Guardar", lo que dejaba sin persistir (o
      // persistida más tarde, ya editada) la versión que el log de auditoría marcaba
      // como "usada". Autoguardar aquí hace que ambas señales coincidan.
      //
      // Desde el 25 ago 2026 la IA ya no propone "Aprovechamiento" (ver comentario en
      // applyAiResult) -- el especialista lo selecciona como siempre, manualmente, en el
      // dropdown de este mismo tab. Este método ahora solo aplica campos 'text' directo a
      // studentFunction[key] (hoy solo "Comentario").
      this.aiModal.fields.forEach((field) => {
        // "editar antes de usar": si el especialista corrigió el texto en la
        // caja de "Redacción Sugerida" (ver aiSuggestionEditMixin.js) ANTES de apretar
        // "Usar Esta Versión", ese texto editado es el que se aplica -- no el que
        // originalmente devolvió la IA.
        const wasEdited = this.aiEditHasEditedText(field);
        const finalText = this.aiEditFinalText(field, 'value');
        if (!finalText) return;

        this.studentFunction[field.key] = finalText;
        // Vincula ESTE guardado con la corrida que lo originó (ver
        // LogAiGenerationAppliedField) SOLO si se usó tal cual, sin editar -- se limpia
        // igual que antes si el especialista edita el campo a mano después (ver los
        // @input de functionLevelDescription/functionImpedimentDescription), y ahora
        // también si la edición pasó por la caja de sugerencia misma, antes de aplicarla
        // (mismo criterio que GoalsManager.vue/SubAreaGoalCallout.vue -->
        // descriptionAiGenerationLogId).
        this.studentFunction[`${field.key}AiGenerationLogId`] = wasEdited
          ? null
          : this.aiModal.aiGenerationLogId;
      });

      // Deja constancia de que ESTA corrida fue la que realmente se usó (ver comentario en
      // markSuggestionUsed). Intencionalmente no bloqueante: es una señal de auditoría/
      // analítica, no debe poder impedirle al especialista usar la sugerencia si el llamado
      // falla (ej. sin red).
      if (this.aiModal.aiGenerationLogId) {
        markSuggestionUsed({
          aiGenerationLogId: this.aiModal.aiGenerationLogId,
        }).catch(() => {});
      }

      this.closeAiAssistant();

      // Mismo flujo que el botón "Guardar" de este tab (ver saveTab() -> store
      // saveChangesOnForm -> this.save() -> POST savestudentfunction); su propio
      // ShowToast informa éxito o error, por eso no se agrega uno aquí.
      this.saveTab();
    },
    // "¿Te fue útil esta sugerencia?" -- feedback explícito sobre la corrida actual, separado
    // de si se usó o no (ver nota en submitFeedback). Optimista: refleja el click al toque y
    // revierte si el POST falla.
    async handleFeedback(liked) {
      const logId = this.aiModal.aiGenerationLogId;
      if (!logId || this.aiModal.feedbackSubmitting) return;

      const previous = this.aiModal.feedback;
      this.aiModal.feedback = liked ? 'up' : 'down';
      this.aiModal.feedbackSubmitting = true;

      try {
        await submitFeedback({ aiGenerationLogId: logId, liked });
      } catch (err) {
        this.aiModal.feedback = previous;
        this.ShowToast(
          '',
          'No se pudo registrar tu respuesta. Intente nuevamente.',
          'error'
        );
      } finally {
        this.aiModal.feedbackSubmitting = false;
      }
    },
  },
  activated() {
    store.commit('setSaveMethod', this.save);
    store.commit('setSaveBtnVisibility', true);
  },
  async mounted() {
    await this.loadResources();
    await this.getApproaches();
    await this.getStudentFunction();

    const academicYearId = store.getters.getPeiInfo.academicYearId;
    const { data } = await getSysparameterByNames({
      parameterNames: [
        'ActivateAssistantServiceNeedGuide',
        'IsEnableInappropiateBehaviourV2',
        'EnableAiAssistantPei',
      ],
      academicYearId,
    });

    this.activateAssistantServiceNeedGuideIsOn =
      data.find((x) => x.name == 'ActivateAssistantServiceNeedGuide')
        ?.staticValue == 'true';
    this.isEnabledInappropriateBehaviorV2 =
      data.find((x) => x.name == 'IsEnableInappropiateBehaviourV2')
        ?.staticValue == 'true';

    // US 156909 - si el parámetro no existe (o está en false), el ícono/botón del
    // Asistente de IA no se muestra. La búsqueda es sin academicYearId como
    // respaldo, por si el parámetro se creó como global (sin año académico).
    const aiParam = data.find((x) => x.name == 'EnableAiAssistantPei');
    if (aiParam) {
      this.aiAssistantParamEnabled = aiParam.staticValue == 'true';
    } else {
      const { data: globalData } = await getSysparameterByNames({
        parameterNames: ['EnableAiAssistantPei'],
      });
      this.aiAssistantParamEnabled =
        globalData.find((x) => x.name == 'EnableAiAssistantPei')
          ?.staticValue == 'true';
    }
  },
};
</script>
<style scoped>
.custom-conduct-container {
  width: 100%;
  float: left;
}

.custom-conduct-container-active {
  background-color: #f5f6f7;
}

.custom-conduct-container-inactive {
  background-color: #fff;
}

.custom-conduct-container .custom-conduct-container-elements {
  width: 95%;
  float: left;
  margin-left: 10px;
  margin-top: 20px;
}
.containerBorder {
  border-bottom: 0.02rem solid #b5c3bc !important;
  margin-bottom: 1%;
}
.custom-conduct-container hr {
  float: left;
  width: 100%;
  border: 0.02rem solid #b5c3bc !important;
}

.custom-conduct-container span.gray-pill {
  background: #b5c3bc;
  padding: 5px 15px 5px 15px;
  border-radius: 20px;
  color: #fff;
}

.custom-conduct-container p {
  margin-left: 15px !important;
  margin-top: 10px !important;
  font-weight: normal;
}

.custom-container {
  float: left;
  width: 50%;
}

.custom-container-header {
  background: #3f5b60;
  padding: 10px 5px 10px 5px;
  margin-bottom: 25px;
}

.custom-container-header span {
  color: #fff;
}
.savecontinue {
  width: 12.4375rem;
}
#accordion {
  float: left;
  width: 100%;
}

/**JOHANS**/
.custom-conduct-add {
  float: left;
}

.custom-conduct-container-elements .information {
  float: left;
  width: 90%;
}
.normalTitle {
  font-weight: normal;
}

.custom-dropdown {
  float: left !important;
  width: 10px !important;
}

.custom-dropdown a {
  width: 100% !important;
  float: left !important;
}

.custom-dropdown span {
  background: none !important;
  color: #000 !important;
  padding: 5px 15px 5px 10px !important;
  float: left;
}

.custom-dropdown i {
  float: left !important;
  margin-top: 10px !important;
  margin-left: 10px;
}

.inappropiate-alternatives {
  margin-top: -1rem;
  margin-bottom: 1rem;
  background-color: rgba(0, 0, 0, 0.03);
}

/****ESTILOS PARA SELECCION**/

.content-selected > p {
  font-size: 1rem;
  font-weight: 400;
  color: #727272;
}
.content-selected {
  width: 100%;
  height: 121px;
  /*margin-left: -1.5%;*/
  margin-top: 0.7%;
  /*padding-left: 3.5%;*/
  padding-top: 1%;
  background-color: #fafbfa;
  box-shadow: inset 0 -8px 12px -3px #e4e6e2;
}
.panel-red {
  display: flex;
  width: 100%;
  flex-direction: row;
  background: #ffebeb;
  border: 1px solid #ff5b5c;
  color: #ff5b5c;
  border-radius: 4px;
  padding: 0.7%;
  padding-left: 1.5%;
  font-size: 14px;
  font-weight: 400;
}
.tag-badge-info-d {
  margin-top: 80px;
}
.custom-dropdown {
  border: 1px solid #2db782;
  border-radius: 4px !important;
  opacity: 1 !important;
}
.resetmargin {
  margin-left: 0px;
}
.areah {
  height: 132px;
}

.saveoffocus {
  padding-top: 100px;
}

.custom-mr {
  margin-right: 20px;
}
.w-99 {
  width: 99% !important;
}

.footer-success {
  margin: 8px !important;
}

.thead-property {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}

.card-pei {
  margin-left: none;
  width: 100%;
  background-color: #ffffff;
  margin-left: 0px;
}

.card-body {
  margin-left: -10px;
}

.card-body >>> .chips-container {
  padding: 0px !important;
  box-shadow: none !important;
  background: #fff;
}

.custom-dropdown-block {
  position: absolute;
  right: 7px;
  top: 0px;
}

.dropdown-divider-custom {
  border-top: 0.02rem solid #b5c3bc !important;
}

/*
  Estilos del CUERPO del AiAssistantModal (III-A/III-B) -- viven acá y no en
  AiAssistantModal.vue porque ese contenido se pasa por slot: en Vue 2, <style scoped> del
  hijo no alcanza al contenido que el padre le pasa por slot (ese contenido se compila con
  el scope-id del PADRE, no del hijo). .ai-modal-context* se deja aunque esa sección esté
  oculta (ver comentario en el template) para que, si se reactiva, ya tenga su estilo listo.
*/
.ai-modal-context {
  background: #e4fff5;
  border-radius: 4px;
  padding: 12px 16px;
  font-family: 'Lato', sans-serif;
}

.ai-modal-context-title {
  font-weight: 700;
  color: #2db782;
  margin-bottom: 6px;
}

.ai-modal-context-list {
  list-style: none;
  padding: 0;
  margin: 0;
  color: #2db782;
  font-size: 14px;
}

.ai-modal-context-list li {
  padding: 2px 0;
}

.ai-modal-context-missing {
  color: #c9545e !important;
}

/* En Figma el texto "Redacción Sugerida:" va en el gris oscuro de marca y el sparkle queda
   violeta (antes ambos iban en verde). El violeta ya no se pinta por CSS: lo trae el propio
   asset sparklesViolet.svg, que además es un degradado. */
.ai-modal-suggestion-title {
  font-family: 'Lato', sans-serif;
  font-size: 15px;
  font-weight: 700;
  color: #11291b;
  display: flex;
  align-items: center;
  gap: 6px;
}

.ai-modal-suggestion {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* justify-content: space-between para que el botón ícono de Editar (ver
   .ai-btn-icon) quede del lado opuesto al label del campo/etiqueta "Editado" -- mismo
   criterio que .ai-goal-suggestion__header en GoalsManager.vue/SubAreaNecessity.vue/
   SubAreaGoalCallout.vue. */
.ai-modal-suggestion-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* ver el mismo comentario en GoalsManager.vue. */
.ai-modal-suggestion-header-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ai-modal-suggestion-label {
  font-family: 'Lato', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #11291b;
}

/* señal SOLO visual de que el texto ya no es el que propuso la IA tal cual -- la
   auditoría real (si el campo quedó vinculado a esta corrida) la decide handleUseVersion, no
   esta etiqueta. Mismo estilo que .ai-goal-suggestion__edited-tag (gris neutro, no verde/
   violeta como las acciones "positivas"). */
.ai-modal-suggestion-edited-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 4px;
  background: #eef0ef;
  color: #57685f;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.ai-modal-suggestion-text {
  /* Borde lila #c1c0f8 (muestreado del mockup de Figma) en vez del gris verdoso anterior. */
  border: 1px solid #c1c0f8;
  border-radius: 4px;
  padding: 10px 12px;
  font-family: 'Lato', sans-serif;
  font-size: 14px;
  line-height: 1.6;
  color: #11291b;
  white-space: pre-wrap;
}

/* "editar antes de usar": reemplaza .ai-modal-suggestion-text mientras
   aiEditIsActive(field) es true (ver template). Mismo foco violeta que ya usa "Refinar
   Resultado" (ver .ai-modal-refine-input:focus más abajo) y que .ai-goal-suggestion__text-edit
   en GoalsManager.vue/SubAreaNecessity.vue, para que se sienta parte del mismo lenguaje visual
   del asistente. */
.ai-modal-suggestion-text-edit {
  display: block;
  width: 100%;
  margin: 0;
  padding: 8px 10px;
  border: 1px solid #a062fb;
  border-radius: 4px;
  outline: none;
  box-shadow: 0 0 0 3px rgba(92, 88, 237, 0.15);
  background: #fff;
  font-family: 'Lato', sans-serif;
  font-size: 14px;
  line-height: 1.6;
  color: #11291b;
  resize: vertical;
}

.ai-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.ai-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 4px;
  padding: 7px 16px;
  font-family: 'Lato', sans-serif;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
}

.ai-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.ai-btn-outline {
  background: #fff;
  border: 1px solid #2db782;
  color: #2db782;
}

/* botón ícono de Editar/Cancelar (ver aiSuggestionEditMixin.js, aiEditToggle): gris
   neutro, no es una acción "positiva" tipo Usar/Regenerar (violeta/verde), es un modo de
   vista. Mismo estilo .ai-btn-icon que GoalsManager.vue/SubAreaNecessity.vue/
   SubAreaGoalCallout.vue. */
.ai-btn-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 4px;
  background: transparent;
  border: none;
  color: #57685f;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s ease-in-out, color 0.15s ease-in-out;
  /* tamaño del ícono FontAwesome (fa-pencil/fa-times) que va adentro -- antes lo daba el
     prop :size del componente SVG propio, ver el comentario del template. */
  font-size: 14px;
}

.ai-btn-icon:hover {
  background: #eef0ef;
}

/* Mientras se está editando (botón mostrando la "X" de Cancelar) -- mismo fondo que
   .ai-goal-suggestion__edited-tag para que se lea como "modo activo", no como error. */
.ai-btn-icon--active {
  background: #eef0ef;
  color: #11291b;
}

/* Violeta (mismo esquema del asistente -- ver AiAssistantModal.vue) para "Usar Esta
   Versión" y "Refinar", como en el mockup de Figma del panel docked -- a diferencia de
   .ai-btn-outline ("Regenerar"), que ahí se ve en verde y por eso no se tocó. */
.ai-btn-primary {
  background: linear-gradient(104deg, #5c58ed 24.303%, #ba65ff 134.64%);
  border: 1px solid #5c58ed;
  color: #fff;
}

.ai-btn-primary:hover:not(:disabled) {
  background: linear-gradient(104deg, #4a45d6 24.303%, #a94dff 134.64%);
}


</style>
